import _ from 'lodash';
const defaultState = {
  userInfo: {},
  department: {},
  unreadCount: 0,
  menuList: [],
  permissionList: [],
  systemConfig: {},
  isAdmin: false,
  fullScreen: true
};

export const state = _.cloneDeep(defaultState);
export const mutations = {
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  setDepartment(state, department) {
    state.department = department;
  },
  setMenuList(state, menuList) {
    state.menuList = menuList;
  },
  setPermissionList(state, permissionList) {
    state.permissionList = permissionList;
  },
  setSystemConfig(state, config) {
    state.systemConfig = config;
  },
  setIsAdmin(state, roleList) {
    if (Array.isArray(roleList)) {
      state.isAdmin = roleList.some(e => {
        return e.code === 'ROLE_ADMIN';
      });
    }
  },
  setFullScreen(state, fullScreen) {
    state.fullScreen = fullScreen;
  },
  clearStore(state, exceptList) {
    Object.keys(state).every(e => {
      if (Array.isArray(exceptList) && exceptList.indexOf(e) !== -1) {
        return true;
      }
      if (typeof defaultState[e] !== 'undefined') {
        state[e] = defaultState[e];
      } else {
        state[e] = null;
      }
      return true;
    });
  }
};
